import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-breathing-animation',
    templateUrl: './breathing-animation.component.svg',
    styleUrls: ['./breathing-animation.component.scss'],
})
export class BreathingAnimationComponent implements OnInit {
    @Input() breatheOutText: string;
    @Input() breatheInText: string;

    constructor() {
    }

    ngOnInit() {
    }

}
